export default __webpack_public_path__ + "static/media/website.72170184.png";